// extracted by mini-css-extract-plugin
module.exports = {"fabContainer":"FloatingActionButton_fabContainer__AXL6s"};